import { render, staticRenderFns } from "./PayFail.vue?vue&type=template&id=343a0304&scoped=true&"
import script from "./PayFail.vue?vue&type=script&lang=ts&"
export * from "./PayFail.vue?vue&type=script&lang=ts&"
import style0 from "./PayFail.vue?vue&type=style&index=0&id=343a0304&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a0304",
  null
  
)

export default component.exports